var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('node-view-wrapper',{class:_vm.className,attrs:{"data-id":_vm.uuid}},[_c('node-view-content',{class:(_vm.className + "__content"),attrs:{"as":"div"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }